import { zSidLabel } from "src/types";
import z from "zod";

export const zAttrPermission = z.enum(["noAccess", "readOnly", "readWrite"]);
export type ZAttrPermission = z.infer<typeof zAttrPermission>;

export const zAttrRoleAccess = z.object({
  ...zSidLabel.shape,
  permission: zAttrPermission,
});
export type ZAttrRoleAccess = z.infer<typeof zAttrRoleAccess>;

export type ZAttrAccess = {
  id: string;
  label: string;
  roles: ZAttrRoleAccess[];
  attributes?: ZAttrAccess[];
};

export const zAttrAccess: z.ZodType<ZAttrAccess> = z.lazy(() =>
  z.object({
    id: z.string(),
    label: z.string(),
    roles: zAttrRoleAccess.array(),
    attributes: z.array(zAttrAccess).optional(),
  }),
);
